import React, { useContext } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import IconLineChart from 'icons/lineChart';
import IconColumnChart from 'icons/iconColumnChart';
import { UiContext } from 'uiContext';
import IconButton from 'controls/buttons/iconButton/iconButton';

export type ChartType = 'line' | 'col';

export default function ChartTypeSwitcher({
  value,
  onChange,
}: {
  value: ChartType;
  onChange: (val: ChartType) => void;
}) {
  const theme = useTheme();

  const {
    spacings: { sp },
  } = useContext(UiContext);

  return (
    <Box sx={{ display: 'flex', gap: sp.s50, alignItems: 'center' }}>
      <Typography
        variant="f16"
        sx={{ color: theme.palette.custom.fontColorNotActive }}
      >
        Режим просмотра:
      </Typography>

      <Box sx={{ display: 'flex' }}>
        <Box
          sx={{
            display: 'flex',
            backgroundColor: '#312C37',
            gap: sp.s30,
            padding: sp.s20,
            borderRadius: '4px',
          }}
        >
          <IconButton
            onClick={() => onChange('col')}
            style={{ padding: sp.s20 }}
            sx={{
              backgroundColor: value === 'col' ? '#2A1149' : undefined,
            }}
          >
            <IconColumnChart />
          </IconButton>

          <IconButton
            onClick={() => onChange('line')}
            style={{ padding: sp.s20 }}
            sx={{
              backgroundColor: value === 'line' ? '#2A1149' : undefined,
            }}
          >
            <IconLineChart />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
}
